import { render, staticRenderFns } from "./SCardProductComp.vue?vue&type=template&id=7c6268b1&"
import script from "./SCardProductComp.vue?vue&type=script&lang=js&"
export * from "./SCardProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports